export enum TemplateFieldSource {
    document,
    workflow
}
